import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPaymentShareMemberSpentAmount } from './payment-share-members-spent-amount.transformers';
import { PaymentShareMembersSpentAmountCollection } from './payment-share-members-spent-amount.types';

export function paymentShareMembersSpentAmountReducer(
  state: CollectionStateSlice<PaymentShareMembersSpentAmountCollection> = {},
  action: CollectionActions<PaymentShareMembersSpentAmountCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'paymentShareMembersSpentAmount') {
        const { result, ref, order } = action.payload;

        if (!result.members) {
          return state;
        }

        return mergeDocuments<PaymentShareMembersSpentAmountCollection>(
          state,
          transformIntoDocuments(
            result.members,
            transformPaymentShareMemberSpentAmount,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
